import * as THREE from 'three';
import { isHole } from '../checking';

export const getHoleNames = (object: THREE.Object3D) => {
  const holes = new Set<string>();
  object.traverse((child) => {
    if (isHole(child)) {
      holes.add(child.name);
    }
  });
  return holes;
};
